import React from 'react';
import { Home, SearchX } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <section className="mx-auto flex min-h-[60vh] max-w-2xl flex-col items-center justify-center rounded-3xl border border-red-100 bg-white px-6 py-16 text-center shadow-sm">
      <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-red-50 text-brand-red">
        <SearchX className="h-10 w-10" />
      </div>

      <p className="text-sm font-semibold uppercase tracking-[0.35em] text-brand-gold">
        404 Not Found
      </p>
      <h1 className="mt-3 text-3xl font-bold text-brand-red sm:text-4xl">
        ไม่พบหน้าที่ต้องการ
      </h1>
      <p className="mt-3 text-gray-600">
        ลิงก์นี้อาจถูกย้าย เปลี่ยนชื่อ หรือไม่มีอยู่ในระบบ
      </p>

      <Button
        size="lg"
        className="mt-8"
        onClick={() => navigate('/', { replace: true })}
      >
        <Home className="h-5 w-5" />
        กลับหน้าแรก
      </Button>
    </section>
  );
}
